export const KMotionUrl = 'https://www.k-motion.com';